module.exports = __webpack_public_path__ + "static/media/logo_light_bg.454eeb74.png";